import { render, staticRenderFns } from "./DotsVerticalIcon.vue?vue&type=template&id=4c0bb458&"
import script from "./DotsVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./DotsVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports